import { library } from "@fortawesome/fontawesome-svg-core"
import {
  faEnvelope,
  faCheck,
  faLock,
  faLockOpen,
  faKey,
  faEdit,
  faSync,
  faArrowCircleUp,
  faArrowCircleDown,
  faPlusCircle,
  faSearch,
  faTriangleExclamation,
  faArrowLeft,
  faArrowRight,
  faStar,
  faDownload,
  faShare,
  faFileExport,
  faFingerprint,
  faCircleNotch,
  faUser,
  faXmark,
  faQrcode,
  faEye,
  faEyeSlash,
  faEllipsisV,
  faWallet,
  faEuroSign,
  faAngleDown,
  faAngleUp,
  faCircleInfo,
  faList,
  faFilePdf,
  faFileCsv,
  faClock,
  faTimesCircle,
  faCheckCircle,
  faBan,
  faPaperPlane,
  faTimes,
  faFileAlt,
  faTrash,
  faCalendarAlt,
  faChevronDown,
  faChevronUp,
} from "@fortawesome/free-solid-svg-icons"
import { faStar as farStar } from "@fortawesome/free-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
library.add(
  faEnvelope,
  faCheck,
  faLock,
  faLockOpen,
  faKey,
  faEdit,
  faSync,
  faArrowCircleUp,
  faArrowCircleDown,
  faPlusCircle,
  faSearch,
  faTriangleExclamation,
  faArrowLeft,
  faArrowRight,
  faStar,
  farStar,
  faDownload,
  faShare,
  faFileExport,
  faFingerprint,
  faCircleNotch,
  faUser,
  faXmark,
  faQrcode,
  faEye,
  faEyeSlash,
  faEllipsisV,
  faWallet,
  faEuroSign,
  faAngleDown,
  faAngleUp,
  faCircleInfo,
  faList,
  faFilePdf,
  faFileCsv,
  faList,
  faEuroSign,
  faClock,
  faTimesCircle,
  faCheckCircle,
  faBan,
  faPaperPlane,
  faTimes,
  faFileAlt,
  faTrash,
  faCalendarAlt,
  faChevronDown,
  faChevronUp
)

export default FontAwesomeIcon
